var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpShoesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#006EFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M949,331c-48-48-113.3-74.5-181-75l-302.8-30.4l-76.4-91.8c-3-3.7-7.5-5.8-12.3-5.8H80c-8.8,0-16,7.2-16,16 v544c0,8.8,7.2,16,16,16h104c4.4,0,8-3.6,8-8v-48c0-4.4-3.6-8-8-8h-56v-64h56c4.4,0,8-3.6,8-8v-48c0-4.4-3.6-8-8-8h-56V384 c45.7,0,88,24.4,110.8,64H309c-26.4-74.5-97.6-128-181-128V192h224l80,96l67.2,6.4l-47.7,143.1c-1.4,4.2,0.9,8.7,5.1,10.1 c0.8,0.3,1.7,0.4,2.5,0.4h41.4c6.9,0,13-4.4,15.2-10.9l45.6-136.8l62,5.9l-43.7,131.2c-1.4,4.2,0.9,8.7,5.1,10.1 c0.8,0.3,1.7,0.4,2.5,0.4h41.4c6.9,0,13-4.4,15.2-10.9l41.6-124.9L768,320c105.9,0,192,86.1,192,192H776c-4.4,0-8,3.6-8,8v48 c0,4.4,3.6,8,8,8h232c8.8,0,16-7.2,16-16v-48C1024.2,444.1,997.2,378.9,949,331z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1216,960H448c-0.1-70.7-57.3-127.9-128-128v128h-64V592c0-8.8,7.2-16,16-16h296.5c4.8,0,9.3,2.1,12.3,5.8 l76.4,91.8l57.3,5.8l-71.2,207.3c-0.8,4.4,2.1,8.5,6.5,9.3c0.5,0.1,0.9,0.1,1.4,0.1h41.4c6.9,0,13-4.4,15.2-10.9h0.1l47-136.6 l21.6-62.9l61.9,6.2l-67,194.8c-0.8,4.3,2.1,8.5,6.5,9.3c0.5,0.1,0.9,0.1,1.4,0.1h41.4c6.9,0,13-4.4,15.2-10.9h0.1l42.9-124.8 l21.4-62.2l59.9,6c67.8,0.4,133.1,27,181,75C1189.2,826.9,1216.2,892.1,1216,960z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,1024v112c0,8.8,7.2,16,16,16h230.1c6.1,0,11.6-3.4,14.3-8.8L544,1088h64l27.6,55.2 c2.7,5.4,8.3,8.8,14.3,8.8H1200c8.8,0,16-7.2,16-16v-112H256z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 448,
    y1: 960,
    x2: 320,
    y2: 960
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpShoesActive);
export default __webpack_public_path__ + "static/media/hp_shoes_active.09232eca5215921c48d8fff40086b3cd.svg";
export { ForwardRef as ReactComponent };